import { forwardRef, useImperativeHandle, useState } from 'react';
import { FrameIdFloatingFilterProps, FrameIdFloatingFilterRef, FrameIdFilterModel } from './types';

export const FrameIdFloatingFilter = forwardRef<FrameIdFloatingFilterRef, FrameIdFloatingFilterProps>(
  ({ showParentFilter }, ref) => {
    const [currentValue, setCurrentValue] = useState('');

    useImperativeHandle(ref, () => ({
      onParentModelChanged(parentModel: FrameIdFilterModel | null) {
        if (!parentModel) {
          setCurrentValue('');
          return;
        }

        const count = parentModel.values?.length || 0;
        setCurrentValue(count > 0 ? `${count} search term${count !== 1 ? 's' : ''}` : '');
      },
    }));

    const handleClick = (): void => {
      showParentFilter();
    };

    return (
      <button
        className="flex items-center h-full px-2 cursor-pointer hover:bg-neutral-50 transition-colors"
        onClick={handleClick}
        type="button"
      >
        <span className="sub-header-sm text-essential-tertiary">{currentValue || 'Filter frame IDs'}</span>
      </button>
    );
  },
);
